/**
 * player.js protokolining minimal mijozi — Bunny Stream iframe'i uchun.
 *
 * NEGA O'ZIMIZNIKI: Bunny pleyer skriptini `assets.mediadelivery.net`
 * dan yuklashni taklif qiladi, lekin backend CSP'si `scriptSrc` uchun
 * faqat `'self'` va telegram.org ga ruxsat beradi — tashqi skript
 * BLOKLANADI. Aynan shu sabab ilgari `pdf.js` worker'i ishlamay
 * qolgan edi (qarang `PdfReader`).
 *
 * npm dagi `player.js` paketi 0.1.0 da qotib qolgan; ~60 qatorlik
 * protokol uchun qarovsiz bog'liqlik olishdan ko'ra o'zimiz yozganimiz
 * ma'qul. Protokol brauzerda sinaldi: `ready`, `timeupdate`, `ended`
 * hodisalari va `setCurrentTime`, `play`, `pause` metodlari.
 *
 * PROTOKOL: ikki tomon `postMessage` bilan JSON almashadi —
 *   biz  -> {context:'player.js', version:'0.0.11', method, value}
 *   u    -> {context:'player.js', event, value}
 */

const CONTEXT = 'player.js';
const VERSION = '0.0.11';

export type PlayerEvent = 'ready' | 'timeupdate' | 'ended' | 'play' | 'pause';

export interface TimeState {
  seconds: number;
  duration: number;
}

export class BunnyPlayer {
  private readonly iframe: HTMLIFrameElement;
  private readonly origin: string;
  private readonly listeners = new Map<string, ((v: any) => void)[]>();
  private readonly onMessage: (e: MessageEvent) => void;
  private ready = false;
  private cancelled = false;
  /*
   * `ready` dan OLDIN yuborilgan xabarlar shu yerda kutadi.
   *
   * Buni brauzerda sinaganda topdim: pleyer tayyor bo'lmasidan
   * yuborilgan `addEventListener` JIMGINA TASHLAB YUBORILADI —
   * `ready` keladi, `timeupdate` esa umuman kelmaydi. Rasmiy
   * kutubxona ham xuddi shunday navbat tutadi.
   */
  private queue: { method: string; value?: unknown }[] = [];

  constructor(iframe: HTMLIFrameElement) {
    this.iframe = iframe;
    // Manzil noto'g'ri bo'lsa ham yiqilmaymiz — `*` ga tushamiz.
    let origin = '*';
    try {
      origin = new URL(iframe.src).origin;
    } catch {
      /* bo'sh yoki nisbiy src */
    }
    this.origin = origin;

    this.onMessage = (e: MessageEvent) => {
      /*
       * Faqat SHU iframe'dan kelgan xabarlar. Tekshiruvsiz sahifadagi
       * boshqa freym (reklama, Telegram) bizning holatimizni
       * o'zgartira olardi.
       */
      if (e.source !== iframe.contentWindow) return;

      let data: any = e.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch {
          return;
        }
      }
      if (!data || data.context !== CONTEXT || !data.event) return;

      if (data.event === 'ready') {
        this.ready = true;
        const waiting = this.queue;
        this.queue = [];
        for (const x of waiting) this.send(x.method, x.value);
      }
      for (const fn of this.listeners.get(data.event) || []) {
        fn(data.value);
      }
    };

    window.addEventListener('message', this.onMessage);
  }

  private send(method: string, value?: unknown): void {
    if (this.cancelled) return;

    // Tayyor emas -> navbatga. `addEventListener` ni ham, `play` ni
    // ham: ikkalasi ham erta yuborilsa yo'qoladi.
    if (!this.ready) {
      this.queue.push({ method, value });
      return;
    }

    const win = this.iframe.contentWindow;
    if (!win) return;
    win.postMessage(
      JSON.stringify({ context: CONTEXT, version: VERSION, method, value }),
      this.origin,
    );
  }

  /**
   * Hodisaga obuna bo'ladi.
   *
   * `addEventListener` pleyerga ham yuboriladi: u faqat so'ralgan
   * hodisalarni jo'natadi, ya'ni obunasiz `timeupdate` umuman kelmaydi.
   */
  on(event: PlayerEvent, fn: (value: any) => void): void {
    const list = this.listeners.get(event) || [];
    list.push(fn);
    this.listeners.set(event, list);
    this.send('addEventListener', event);
  }

  play(): void {
    this.send('play');
  }

  pause(): void {
    this.send('pause');
  }

  /** Berilgan soniyaga o'tkazadi (davom ettirish uchun). */
  setCurrentTime(seconds: number): void {
    this.send('setCurrentTime', seconds);
  }

  get isReady(): boolean {
    return this.ready;
  }

  /**
   * Tinglovchini olib tashlaydi.
   *
   * SHART: komponent yo'q qilinganda chaqirilmasa, `window` ga
   * ulangan tinglovchi qolib ketadi va har bir dars ochilishida
   * yangisi qo'shilaveradi — eski holatga yozishga urinadigan
   * "arvoh" obunachilar paydo bo'ladi.
   */
  destroy(): void {
    this.cancelled = true;
    this.listeners.clear();
    window.removeEventListener('message', this.onMessage);
  }
}
